import { tokens } from '@/locales/translations/tokens';
import {
  Lightbulb,
  Search,
  Sparkles,
  Users,
  Newspaper,
  Clock,
  Rss,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function useProductsMenu() {
  return [
    {
      icon: Search,
      label: 'AI Search',
      link: '/products/workstation',
      description: 'Your Intelligent Search Solution.',
    },
    {
      icon: Lightbulb,
      label: 'AI Knowledge Management',
      link: '/products/assistant',
      description: 'Centralized Knowledge Repository.',
    },
    {
      icon: Sparkles,
      label: 'AI Agent',
      link: '/products/agent',
      description: 'Advanced Smart Assistant.',
    },
  ]
}

export function useDocumentationMenu() {
  const { t } = useTranslation();
  return [
    {
      icon: Users,
      label: t(tokens.landing.community_title),
      link: '/community',
      description: t(tokens.landing.community_description),
    },
    {
      icon: Rss,
      label: 'Blog',
      link: '/blog',
      description: 'Confira os posts mais recentes',
    }
  ]
}

export function usePagesBlog() {
  const { t } = useTranslation();
  return [
    {
      icon: Newspaper,
      label: t(tokens.landing.latest_posts_title),
      link: 'community',
      description: t(tokens.landing.latest_posts_description),
    },
    {
      icon: Clock,
      label: t(tokens.landing.recent_updates_title),
      link: 'community',
      description: t(tokens.landing.recent_updates_description),
    },
  ]
}
